export default __webpack_public_path__ + "static/media/avatar-2.feb0f89d.jpg";